import { ModelEvent } from "../EventManagement/ModelEvents/ModelEvent";
import { ServerChangeSet } from "../../../../../Common/CandyApiClient/Types/ChangeSet/ServerChangeSet";
import { AbsoluteModelFieldPath } from "../../../../../Common/ModelPath/AbsoluteModelFieldPath";
import { IInnerChangeResult } from "../../../../../Common/CandyApiClient/ICandyApiClient";

import { ChangeSet } from "./ChangeSet";
import { SendChangeSetOptions } from "./ChangeSetManager";

export class ConflictChangeSetError extends Error {}

export type ChangesCallback = (
    originalChangeSet: ServerChangeSet,
    queuedChangeSets: Iterable<ChangeSet>,
    paths: AbsoluteModelFieldPath[]
) => Promise<void>;

export type InnerChangingAction = () => Promise<IInnerChangeResult>;

export interface IChangeSetManager {
    applyEvents(events: readonly ModelEvent[]): void;
    onServerChangesReceived(callback: ChangesCallback): () => void;
    send(options?: SendChangeSetOptions): Promise<void>;
    scheduleInnerChangeAction(action: InnerChangingAction): Promise<void>;
    sendSync(): void;
    startAutosend(sendInterval?: number): void;
    stopAutosend(): void;
    redefine(): void;
    isRedefined(): boolean;
    dropRedefined(): void;
    mergeRedefined(): void;
    __testOnly__getChangeSetToSend(): ChangeSet;
    setCurrentDataVersion(version: number): void;
}
